import { Dropdown } from "@amzn/storm-ui";
import { useStore } from "zustand";

import { IHubContentProviderToSortAttributeMap } from "../../../constants/filters";
import { discoveryFilterStore } from "../../../store/filters";
import { IHubContentProvider } from "../../../types/providers";
import { renderDropdownItems } from "../../common/DropdownHelpers";

const LABEL = "Sort by";

export const SearchSortDropdown: React.FunctionComponent = () => {
    const [marketingContentFilters, setSortAttribute] = useStore(
        discoveryFilterStore,
        (state) => [state.MARKETING_CONTENT.filters, state.setSortAttribute],
    );

    const iHubContentProvider = IHubContentProvider.MARKETING_NARRATIVES;
    const sortAttribute =
        marketingContentFilters?.[iHubContentProvider]?.sortAttribute;
    const items = IHubContentProviderToSortAttributeMap[iHubContentProvider];

    const { renderItems } = renderDropdownItems(items, false);

    return (
        <Dropdown
            selectedValue={sortAttribute}
            label={LABEL}
            inline={true}
            onChange={setSortAttribute}
            data-testid="search-sort-dropdown"
        >
            {renderItems}
        </Dropdown>
    );
};
